<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue'
  import SettingsPage from '@/components/app/settings/SettingsPage.vue'
  import { type CustomerUser as User } from '@/types/generated'

  import SelectField from '@/components/admin/form/SelectField.vue'

  import { useUserStore } from '@/shared/stores/userStore'

  const { fetchUser } = useUserStore()
  const user = computed<User>(() => useUserStore().user)

  onMounted(async () => {
    const fetching = []
    if (!user.value) {
      fetching.push(fetchUser())
    }
    await Promise.all(fetching)
  })

  const baseSettings = ref({
    ai: 'OpenAI'
  })
</script>

<template>
  <SettingsPage v-if="user">
    <template #actions></template>
    <div class="w-1/2 space-y-4">
      <SelectField
        v-model="baseSettings.ai"
        :options="[{ value: 'OpenAI', title: 'OpenAI' }]"
        name="law_field"
        title="ai_chat"
        label="Chat"
        :disabled="true"
      />
      <SelectField
        v-model="baseSettings.ai"
        :options="[{ value: 'OpenAI', title: 'OpenAI' }]"
        name="law_field"
        title="ai_chat"
        label="Analyse von Dokumenten"
        :disabled="true"
      />
      <SelectField
        v-model="baseSettings.ai"
        :options="[{ value: 'OpenAI', title: 'OpenAI' }]"
        name="law_field"
        title="ai_chat"
        label="Generierung von Dokumenten"
        :disabled="true"
      />
    </div>
  </SettingsPage>
</template>

<style scoped></style>
